import React, { useCallback, useState } from "react";
import {
  TextInput,
  SelectBoxForCategory,
  SelectBoxForMaker,
  SelectBoxForShop,
  SelectBox,
  PrimaryButton,
} from "../components/UIkit";
import { saveProduct } from "../reducks/products/operations";
import ImageArea from "../components/products/ImageArea";
import { useEffect } from "react";
import {
  doc,
  getDoc,
  getDocs,
  query,
  collection,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import { SetSizeArea } from "../components/products";
import { getCategories } from "../reducks/categories/selectors";
import { getShops } from "../reducks/shops/selectors";
import { getMakers } from "../reducks/makers/selectors";
import { fetchCategories } from "../reducks/categories/operations";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../reducks/products/selectors";
const ProductEdit = () => {
  const dispatch = useDispatch();
  const products = useSelector(getProducts);
  let id = window.location.pathname.split("product/edit")[1];
  // const selector = useSelector(state  => state);
  const categories = useSelector(getCategories);
  const shops = useSelector(getShops);
  const makers = useSelector(getMakers);
  if (id !== "" && id !== undefined) {
    id = id.split("/")[1];
  }
  const [name, setName] = useState(""), //名称
    [description, setDescription] = useState(""), //説明
    [images, setImages] = useState([]), //画像
    [category, setCategory] = useState(""), //カテゴリ
    //[categories, setCategories] = useState([]),//カテゴリ
    //   [gender, setGender] = useState(""),//性別
    [embroidery, setEmbroidery] = useState("無"),
    [price, setPrice] = useState(""), //価格
    [prices, setPrices] = useState([]), //価格
    [sizes, setSizes] = useState([]), //サイズ
    [maker, setMaker] = useState(""), //メーカー
    [idin, setIdin] = useState(""), //社内品番
    [idout, setIdout] = useState(""), //社外品番
    [shop, setShop] = useState(""), //購入先名
    [displayProperty, setDisplayProperty] = useState("表示"), //表示・非表示
    [orderNo, setOrderNo] = useState(0); //表示順
  //メモ化-パフォーマンス向上
  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );
  const inputDescription = useCallback(
    (event) => {
      setDescription(event.target.value);
    },
    [setDescription]
  );
  const inputPrice = useCallback(
    (event) => {
      setPrice(event.target.value);
    },
    [setPrice]
  );
  const inputIdin = useCallback(
    (event) => {
      setIdin(event.target.value);
    },
    [setIdin]
  );
  const inputIdout = useCallback(
    (event) => {
      setIdout(event.target.value);
    },
    [setIdout]
  );

  /*const categories = [
        {id:"tops", name:"トップス"},
        {id:"shirts", name:"シャツ"},
        {id:"pants", name:"パンツ"},
    ];*/
  /*
    const categories = [
        {id:"cat001", name:"工場作業服"},
        {id:"cat002", name:"防寒服・空調服"},
        {id:"cat003", name:"現場作業服"},
        {id:"cat004", name:"アムト作業服"},
        {id:"cat006", name:"男性事務服"},
        {id:"cat007", name:"女性事務服"},
        {id:"cat008", name:"女性作業服"},
        {id:"cat009", name:"安全靴"},
        {id:"cat010", name:"革手袋"},
        {id:"cat011", name:"手袋"},
        {id:"cat012", name:"飴"},
        {id:"cat013", name:"空調服オプション"},
        {id:"cat014", name:"腰部骨盤ベルト"},
        {id:"cat015", name:"ポロシャツ(間接・営業)"},
    ];*/

  // const genders = [
  //     {id:"all", name:"すべて"},
  //     {id:"male", name:"メンズ"},
  //     {id:"female", name:"レディース"},
  // ];
  /*const shops =[
        {id:"S001", name:"㈱ワークシステム"},
        {id:"S002", name:"㈱澤商"},
        {id:"S003", name:"ミズノ"},
        {id:"S004", name:"㈱マルケイキタガワ"},
    ]
    const makers =[
        {id:"M001", name:"-"},
        {id:"M002", name:"ミズノ"},
        {id:"M003", name:"サンエス"},
        {id:"M004", name:"川西工業"},
        {id:"M005", name:"AITOZ"},
        {id:"M006", name:"ジーベック"},
    ]*/
  const embroideries = [
    { id: "無", name: "無" },
    { id: "有", name: "有" },
  ];
  const displayProperties = [
    { id: "表示", name: "表示" },
    { id: "非表示", name: "非表示" },
  ];

  useEffect(() => {
    if (id !== "" && id !== undefined) {
      const docRef = doc(db, "products", id);
      // ドキュメントのデータを取得
      getDoc(docRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setName(data.name);
          setDescription(data.description);
          setImages(data.images);
          setEmbroidery(data.embroidery);
          setCategory(data.category);
          setPrice(data.price);
          setSizes(data.sizes);
          setShop(data.shop);
          setIdin(data.idin);
          setIdout(data.idout);
          setMaker(data.maker);
          setDisplayProperty(data.display);
          setOrderNo(data.orderNo);
        } else {
          // ドキュメントが存在しない場合の処理
        }
      });
    }
  }, [id]); //どっちでもいい
  /*
    useEffect(() => {
        /*const fetchCategories = async () => {
            const q = query(collection(db, 'categories'), orderBy('cid', 'asc'));
            const querySnapshot = await getDocs(q);
            const list = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                list.push({
                    id: data.cid,
                    name: data.name
                });
            });
            setCategories(list);
        };
        fetchCategories();
        //dispatch(fetchCategories());
    }, []);*/
  return (
    <section>
      <h2 className="u-text__headline u-text-center">商品の登録・編集</h2>
      <div className="c-section-container">
        <ImageArea images={images} setImages={setImages} />
        <SelectBox
          label={"表示・非表示"}
          options={displayProperties}
          required={true}
          select={setDisplayProperty}
          value={displayProperty}
        />
        <TextInput
          fullWidth={true}
          label={"社内品番"}
          multiline={false}
          required={true}
          onChange={inputIdin}
          minRows={1}
          value={idin}
          type={"number"}
        />
        <TextInput
          fullWidth={true}
          label={"社外品番"}
          multiline={false}
          required={true}
          onChange={inputIdout}
          minRows={1}
          value={idout}
          type={"text"}
        />
        <SelectBoxForMaker
          label={"メーカー"}
          options={makers}
          required={true}
          select={setMaker}
          value={maker}
        />
        <SelectBoxForShop
          label={"購入先"}
          options={shops}
          required={true}
          select={setShop}
          value={shop}
        />
        <TextInput
          fullWidth={true}
          label={"商品名"}
          multiline={false}
          required={true}
          onChange={inputName}
          minRows={1}
          value={name}
          type={"text"}
        />

        <TextInput
          fullWidth={true}
          label={"商品説明"}
          multiline={true}
          required={true}
          onChange={inputDescription}
          minRows={5}
          value={description}
          type={"text"}
        />
        <SelectBoxForCategory
          label={"カテゴリー"}
          options={categories}
          required={true}
          select={setCategory}
          value={category}
        />
        <SelectBox
          label={"刺繍"}
          options={embroideries}
          required={true}
          select={setEmbroidery}
          value={embroidery}
        />
        <TextInput
          fullWidth={true}
          label={"表示価格"}
          multiline={false}
          required={true}
          onChange={inputPrice}
          minRows={1}
          value={price}
          type={"text"}
        />
        <div className="module-spacer--small" />
        <SetSizeArea sizes={sizes} setSizes={setSizes} />
        <div className="module-spacer--small" />
        <div className="center">
          <PrimaryButton
            label={"上書き保存"}
            onClick={() =>
              dispatch(
                saveProduct(
                  id,
                  name,
                  description,
                  category,
                  embroidery,
                  price,
                  images,
                  sizes,
                  maker,
                  idin,
                  idout,
                  shop,
                  displayProperty,
                  orderNo,
                  products.length + 1
                )
              )
            }
          />
          {id !== "" && (
            <PrimaryButton
              label={"別の商品として保存"}
              onClick={() =>
                dispatch(
                  saveProduct(
                    "",
                    name,
                    description,
                    category,
                    embroidery,
                    price,
                    images,
                    sizes,
                    maker,
                    idin,
                    idout,
                    shop,
                    displayProperty,
                    orderNo,
                    products.length + 1
                  )
                )
              }
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductEdit;
